<mat-sidenav-container (backdropClick)="close()" fullscreen [hasBackdrop]="hasBackdrop">
  <mat-sidenav
    #sidenav
    disableClose
    [mode]="mode"
    [position]="'end'"
    class="sidenav-crud"
    [opened]="state.sidenavOpened"
  >
    <div *ngIf="state.sidenavOpened" class="sidenav-crud-inner">
      <div *ngIf="!state.isHeaderHidden" class="sidenav-crud-header">
        <y42-title
          *ngIf="state.titleFormControl"
          class="w-full"
          [formControl]="state.titleFormControl"
          ngDefaultControl
        ></y42-title>
        <h4 *ngIf="state.titleString" class="sidenav-crud-header-name">{{ state.titleString }}</h4>
        <button
          *ngIf="!state.isCloseButtonHidden"
          mat-icon-button
          (click)="close()"
          class="header-close-icon custom-button-icon-big"
          data-test="button"
          [attr.data-test]="'container-with-side-detail-view-button-close'"
        >
          <y42-icon icon="times"></y42-icon>
        </button>
      </div>
      <div class="sidenav-crud-content">
        <ng-container [ngTemplateOutlet]="sideDetailViewContent.templateRef"></ng-container>
      </div>
      <div class="sidenav-crud-footer">
        <ng-container [ngTemplateOutlet]="state.footer"></ng-container>
      </div>
    </div>
  </mat-sidenav>

  <mat-sidenav-content class="datos-card-wrapper pl-0" [ngClass]="contentClasses">
    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>
